<div class="time-picker">
  <mat-form-field appearance="outline">
    <mat-label>{{ label }}</mat-label>
    <input matInput type="text" [value]="value" [placeholder]="placeholder || 'HH:MM'" [disabled]="disabled" (input)="onInputChange($event)" (blur)="onBlur()">
    <mat-icon matSuffix [matMenuTriggerFor]="timeMenu">access_time</mat-icon>
  </mat-form-field>
  
  <mat-menu #timeMenu="matMenu" class="time-menu">
    <div class="picker-content">
      <div class="wheels">
        <div class="wheel" *ngFor="let type of ['hour', 'minute']">
          <div class="label">{{ type === 'hour' ? 'HH' : 'MM' }}</div>
          <div class="container" (wheel)="onWheel($event, type)">
            <div class="items" [style.transform]="'translateY(' + (type === 'hour' ? hourOffset : minuteOffset) + 'px)'">
              <div class="item" 
                   *ngFor="let val of (type === 'hour' ? hours : minutes); let i = index"
                   [class.selected]="(type === 'hour' ? hour : minute) === val"
                   [class.fade]="Math.abs(i - (type === 'hour' ? hour : minute)) > 2"
                   (click)="selectTime(val, type)">
                {{ formatNumber(val) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-menu>
</div>
